import {giftSvg as Icon__small__giftSvg} from '../Icon__small/Icon__small--gift.js';
import {giftSvg as Icon__xsmall__giftSvg} from '../Icon__xsmall/Icon__xsmall--gift.js';

export var gift = {
  name: 'gift',
  category: 'icon',
  colorable: true,
  svg: Icon__small__giftSvg,
  alt: {
    Icon__small: Icon__small__giftSvg,
    Icon__xsmall: Icon__xsmall__giftSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall'],
};
